import clsx from 'clsx';
import React from 'react';
import {SanityModuleConfig} from '../../types';

type Props = {
  children?: React.ReactNode;
  className?: string;
} & SanityModuleConfig;

const ModuleWrapper: React.FC<Props> = ({
  children,
  className,
  paddingTop,
  paddingBottom,
  slug,
  bgColor,
}: Props) => {
  const paddingClasses = clsx([
    paddingTop === 'small' && 'pt-space-s',
    paddingTop === 'medium' && 'pt-space-m',
    paddingTop === 'large' && 'pt-space-l',
    paddingBottom === 'small' && 'pb-space-s',
    paddingBottom === 'medium' && 'pb-space-m',
    paddingBottom === 'large' && 'pb-space-l',
  ]);

  return (
    <section
      style={{
        backgroundColor:
          typeof bgColor === 'string'
            ? bgColor
            : bgColor?.value
            ? bgColor?.value
            : bgColor?.hex,
      }}
      className={`${className} ${paddingClasses} z-1 relative w-full`}
      id={slug && slug?.current}
    >
      {children}
    </section>
  );
};

export default ModuleWrapper;
